"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMarkerjsMarkersState = exports.isNodeMarkupMarkersState = exports.isCroproEditsState = exports.isNodeMarkupEditsState = void 0;
function isNodeMarkupEditsState(state) {
    return state.type === 'NODE_MARKUP' && Object.prototype.hasOwnProperty.call(state.data, 'crop');
}
exports.isNodeMarkupEditsState = isNodeMarkupEditsState;
function isCroproEditsState(state) {
    return state.type === 'CROPRO';
}
exports.isCroproEditsState = isCroproEditsState;
function isNodeMarkupMarkersState(state) {
    return state.type === 'NODE_MARKUP' && Array.isArray(state.data);
}
exports.isNodeMarkupMarkersState = isNodeMarkupMarkersState;
function isMarkerjsMarkersState(state) {
    return state.type === 'MARKER_JS';
}
exports.isMarkerjsMarkersState = isMarkerjsMarkersState;
